<template>
  <div class="page--login">
    <OverlayLoader v-if="loading"></OverlayLoader>
    <div class="login-left">
      <img class="login-bg" src="../../assets/images/login-pic.jpg">
      <img class="login-bg-m" src="../../assets/images/login-pic-m.jpg">
    </div>

    <div class="login-right">
      <div class="login-right-content">
        <!-- step 1 -->
        <template v-if="step === 1">
          <h1>Welcome!</h1>
          <div class="form-row">
            <div class="form-cell">
              <div class="form-block">
                <label>Log in by email address</label>
                <p class="login-info">Please provide your work email address. We will send you an email containing the activation PIN.</p>
                <div class="input-wrapper">
                  <i class="icon-mail"></i>
                  <input type="email" v-model="email" placeholder="Enter your e-mail address" @keyup.enter="submitEmail()" @keyup="error=''">
                </div>
                <div v-if="error" class="form-error">
                  <i class="icon-error"></i>
                  {{error}}
                </div>
              </div>
              <button class="button--submit" @click="submitEmail()">Submit</button>
              <div class="form-block request-access">
                <p class="login-info">If you have not been granted access, please<a @click="step = 3">Request Access</a> </p>
              </div>
            </div>
            <div class="form-cell">
              <label>Log in with SSO</label>
              <p class="login-info">If you would like to not enter the PIN and login using Capgemini SSO</p>
              <button class="button--submit" @click="logWithSSO()">Log in with SSO</button>
            </div>
          </div>
        </template>

        <!-- step 2 -->
        <template v-if="step === 2">
          <h1>Enter PIN</h1>
          <div class="form-row">
            <div class="form-cell">
              <div class="form-block form-block--pin">
                <p class="login-info">We’ve sent an email containing the activation PIN to: <b>{{email}}</b></p>
                <div class="inputs-row">
                  <input type="text" maxlength="1" v-model="pin[0]" placeholder="-" @keyup="nextInput($event,2)">
                  <input type="text" maxlength="1" v-model="pin[1]" placeholder="-" @keyup="nextInput($event,3)">
                  <input type="text" maxlength="1" v-model="pin[2]" placeholder="-" @keyup="nextInput($event,4)">
                  <input type="text" maxlength="1" v-model="pin[3]" placeholder="-" @keyup.enter="login()">
                </div>
                <input type="text" v-model="code" class="hidden" @keyup.enter="login()" @keyup="error=''">
                <div class="form-error" v-if="error">
                  <i class="icon-error"></i>
                  {{error}}
                </div>
              </div>
<!--              <p class="login-info">Haven’t received an email? <a>Try again</a></p>-->
              <button class="button--submit" @click="login()">Log in</button>
            </div>
          </div>
        </template>

        <!-- step 3 -->
        <template v-if="step === 3">
          <h1>Request access</h1>
          <div class="form-row">
            <div class="form-cell">
            <div class="form-block">
              <p class="login-info">Please provide your work email address.</p>
              <div class="input-wrapper">
                <i class="icon-mail"></i>
                <input type="email" v-model="email" placeholder="Enter your e-mail address">
              </div>
            </div>
<!--            <div class="form-block">-->
<!--              <p class="login-info">Please select the name of the account or organisation you want to access:</p>-->
<!--              <div class="input-wrapper">-->
<!--                <input type="text" v-model="account" placeholder="Account/Organisation">-->
<!--              </div>-->
<!--              <div class="form-error" v-if="false">-->
<!--                <i class="icon-error"></i>-->
<!--                Error-->
<!--              </div>-->
<!--            </div>-->
            <button class="button--submit" @click="submitRequestAccess()">Confirm</button>
            </div>
          </div>
        </template>
        <template v-if="step === 4">
          <h1>Request access</h1>
          <div class="form-block">
            <p class="login-info">You've now sent your request to the Engage admin. Once the admin approves your request, you will see the Engage Instance.</p>
          </div>
        </template>
      </div>
      <div class="login-footer">All rights reserved by Capgemini. <br>Copyright © {{ new Date().getFullYear() }}</div>
    </div>
  </div>
</template>

<script>
import auth from '@/api/auth'
import OverlayLoader from "@/components/general/OverlayLoader";

export default {
name: "Login",
  components: {OverlayLoader},
  data() {
  return {
    email: '',
    code: '',
    step: 1,
    pin: [],
    account: '',
    error: '',
    user: {},
    loading: false,
  }
},
watch: {
  pin: function () {
    this.code = ''
    for (var i = 0; i < this.pin.length; ++i) {
      if (this.pin[i]) {
        this.code += this.pin[i]
      } else {
        this.code += '-'
      }
    }
  }
},
mounted() {
  this.$store.dispatch('clearStorage')
},
methods: {
  nextInput (e, input) {
    if(e.key === "Backspace" || e.key === "Delete") {
      return // Don't do anything to the input value
    }
    document.querySelector('.inputs-row input:nth-child('+input+')').focus()
  },
  submitEmail() {
    this.loading = true;
    auth.register({
      email: this.email
    }, () => {
      this.loading = false;
      this.step = 2;
    }, (error) => {
      this.loading = false;
      this.error = 'Invalid domain: Please use your business address or/and check spelling.'
      console.log(error)
    })
  },
  login() {
    this.loading = true;
    auth.validateCode({
      email: this.email,
      code: this.code,
      deviceID: "Browser",
      deviceName: "123",
      deviceType: "Browser"
    }, (response) => {
      if(response.code === 'ok') {
        this.$store.dispatch('setToken', response.token)
        this.$store.dispatch('setUserCompanies', response.companies)
        this.$store.dispatch('isMACSverseUser',false)
        this.$store.dispatch('setPublicUser',false)
        if(this.$store.getters.initLocation) {
          this.loading = false;
          this.$router.push(this.$store.getters.initLocation)
          this.$store.dispatch('setInitLocation', null)
          return
        }
        this.$router.push('/company-select')
      } else {
        this.error = 'Invalid activation PIN: please try again'
        this.loading = false;
      }
    })
  },
  submitRequestAccess() {
    auth.requestAccess({
      email: this.email,
      requestNotes: this.account
    }, () => {
      this.loading = false;
      this.step = 4;
    }, (error) => {
      this.loading = false;
      this.error = 'Invalid domain: Please use your business address or/and check spelling.'
      console.log(error)
    })
  },
  logWithSSO() {
    this.$store.dispatch('setEmail', this.email)
    location.href = 'https://signin.capgemini.com/as/authorization.oauth2?response_type=code&client_id=capgeminiengage&redirect_uri=https%3A%2F%2Fengage.edge.capgemini.com%2Fauthenticate&state=webstage&scope=openid'  }
}
}
</script>

<style scoped>

</style>
